<template>
  <div class="style-item">
    <el-icon
      class="icon"
      @click="handleRemoveClick(index)"
      title="删除"
    >
      <Delete />
    </el-icon>
    <styleRule
      :data="data.conditions"
      :formDef="defaultForm"
      :level="1"
      :styleConfig="{
        size: 'small'
      }"
    />
    <div class="style-detail">
      <form-item labelAlign="left" label="图标" style="width: 300px;">
        <el-select
          size="small"
          v-model="data.iconType"
          placeholder=""
        >
          <el-option label="下箭头" value="down"></el-option>
          <el-option label="上箭头" value="up"></el-option>
        </el-select>
      </form-item>
      <form-item labelAlign="left" label="颜色">
        <el-color-picker
          size="small"
          :predefine="predefineColors"
          v-model="data.color"
        ></el-color-picker>
      </form-item>
    </div>
  </div>
</template>
  
<script setup>
import styleRule from './styleRule.vue';
import { predefineColors } from "@/option/common/dict.js";
import { Delete } from "@element-plus/icons-vue";

const defaultForm = {};
const emit = defineEmits(["handleRemove"]);
const props = defineProps({
  data: {
    type: Object,
    default: function () {
      return {};
    },
  },
  index: {
    type: Number,
    default: 1,
  }
});

const handleRemoveClick = (index) => {
  emit('handleRemove', index)
}

</script>
  
<style scoped lang="scss">
.style-detail {
  display: flex;
}
.style-item {
  padding: 16px;
  background-color: #666666;
  margin-bottom: 10px;
  position: relative;
  .icon {
    position: absolute;
    right: 16px;
    top: 16px;
    color: #ffffff;
  }
}
</style>
  